import { gql } from "@apollo/client";

export const FIND_ALL_PLAN_ACTIVATIONS_BY_PLAN = gql`
  query FindAllPlanActivationsByPlan($uuid: ID!) {
    findAllPlanActivationByPlan(uuid: $uuid) {
      level
      criteria
      uuid
    }
  }
`;

export const CREATE_PLAN_ACTIVATION = gql`
  mutation PlanActivation($data: CreatePlanActivationInput!) {
    createPlanActivation(data: $data) {
      level
      criteria
      uuid
    }
  }
`;

export const UPDATE_PLAN_ACTIVATION = gql`
  mutation PlanActivation($data: UpdatePlanActivationInput!) {
    updatePlanActivation(data: $data) {
      level
      criteria
      uuid
    }
  }
`;

export const DELETE_PLAN_ACTIVATION = gql`
  mutation DeletePlanActivation($uuid: ID!) {
    deletePlanActivation(uuid: $uuid) {
      level
      criteria
      uuid
    }
  }
`;
